import { AuditLog } from "./AuditLog";
import { createRequiredValidators } from './../../../validation/model/Validators';

export function createAuditLogValidators() {
    return [
        ...createRequiredValidators<AuditLog>(["timestamp", "action", "user", "type", "idValue", "field", "oldValue", "newValue", "succes"]),
    ];
}
